import { memo } from 'react'

import {
	EuiAccordion,
	EuiText,
	useGeneratedHtmlId
} from '@equipmentshare/ds2'

import { PermissionGrant } from '../../../../../graphql'
import { BranchWithInventoryLocations, InventoryLocationWithLabel } from 'hooks/inventory-location-search'
import InventoryLocation from '../InventoryLocation'

export type BranchProps = {
	branch: BranchWithInventoryLocations,
	onEditLocation: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
	onSetDefault: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
	onDeleteLocation: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
	onMoveLocation: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
	onWarehouseSettings: ( inventoryLocation: InventoryLocationWithLabel ) => ( e: React.MouseEvent ) => void,
  userPermissions: PermissionGrant[],
	isExpanded: boolean,
	onToggleExpanded: ( id: number ) => void,
}

function Branch( { branch, onEditLocation, onSetDefault, onMoveLocation, onDeleteLocation, onWarehouseSettings, userPermissions, isExpanded, onToggleExpanded }: BranchProps ) {
	const accordionId = useGeneratedHtmlId( { prefix: 'branch' } )

	return (
		<EuiAccordion
			id={accordionId}
			buttonContent={
				<EuiText size="m" style={{ fontWeight: 'bold' }}>{branch.name}</EuiText>
			}
			paddingSize="l"
			forceState={isExpanded ? 'open' : 'closed'}
			onToggle={() => onToggleExpanded( branch.id )}
		>
			{ /* Only mount the location rows while the branch is expanded. A collapsed branch */ }
			{ /* renders no rows, which keeps the page light when there are many stores/branches. */ }
			{ isExpanded && branch.inventoryLocations?.map( ( inventoryLocation ) => (
				<InventoryLocation
					key={`il-${inventoryLocation.id}`}
					inventoryLocation={inventoryLocation}
					onEditLocation={onEditLocation}
					onSetDefault={onSetDefault}
					onDeleteLocation={onDeleteLocation}
					onMoveLocation={onMoveLocation}
					onWarehouseSettings={onWarehouseSettings}
					userPermissions={userPermissions}
					totalNumberOfInventories={branch.inventoryLocations.length}
				/>
			) ) }
		</EuiAccordion>
	)
}

const MemoizedBranch = memo( Branch )
MemoizedBranch.displayName = 'Branch'

export default MemoizedBranch
